import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {
  MarketingDetailCategoryInterface,
  MarketingDetailGroupInterface,
  SavingsSourceEnum
} from '../../../models/marketing-detail.model';
import {FOOTER_GROUP_NAME, DEFAULT_FOOTER_VALUE} from '../../../constants/marketing-detail.constants';
import {resolveXrayExamStatement} from '../../../utils/xray-exam-statement.util';

@Component({
  selector: 'app-common-dental-savings',
  templateUrl: './common-dental-savings.component.html',
  styleUrls: ['./common-dental-savings.component.scss'],
  standalone: false
})
export class CommonDentalSavingsComponent implements OnChanges {
  @Input() public commonDentalPlanSavings: MarketingDetailCategoryInterface | null = null;

  public readonly FOOTER_GROUP: string = FOOTER_GROUP_NAME;
  public readonly DEFAULT_FOOTER: string = DEFAULT_FOOTER_VALUE;
  public footer: string = DEFAULT_FOOTER_VALUE;

  public get isFeeScheduleView(): boolean {
    return this.commonDentalPlanSavings?.savingsSource === SavingsSourceEnum.FEE_SCHEDULE;
  }

  public getShowAdaCode(): boolean {
    return !this.isFeeScheduleView;
  }

  public getCdpsColumnClass(): string {
    return this.isFeeScheduleView ? 'col-6' : 'col-4';
  }

  public getMemberColumnLabel(): string {
    return this.isFeeScheduleView ? 'Member Savings*' : 'Member Pays*';
  }

  public getXrayExamStatement(): string {
    return resolveXrayExamStatement(this.commonDentalPlanSavings?.xrayExamFooterText);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['commonDentalPlanSavings']) {
      this._extractFooter();
    }
  }

  private _extractFooter(): void {
    this.footer = DEFAULT_FOOTER_VALUE;

    if (!this.commonDentalPlanSavings?.groups) {
      return;
    }

    const footerGroup: MarketingDetailGroupInterface | undefined = this.commonDentalPlanSavings.groups
      .find((group: MarketingDetailGroupInterface) => group.itemName === FOOTER_GROUP_NAME);

    if (footerGroup && footerGroup.items.length) {
      this.footer = footerGroup.items[0].description;
    }
  }
}
